import { TextField } from '@mui/material';
import React, { useState } from 'react';

function formatNumber(value) {
  if (typeof value !== 'number') {
    return '';
  }
  return value.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false,
  });
}

function parseNumber(str) {
  if (!str) {
    return null;
  }
  return parseFloat(str.replace(',', '.'));
}

function NumberField({ value, onChange, onBlur, ...props }) {
  const [formattedValue, setFormattedValue] = useState(formatNumber(value));

  const handleChange = e => {
    const newValue = e.target.value;

    if (/^[0-9]*,?[0-9]*$/.test(newValue) || newValue === '') {
      setFormattedValue(e.target.value);

      if (onChange && typeof onChange === 'function') {
        const fakeEvent = { ...e };
        fakeEvent.target.value = parseNumber(newValue);
        onChange(fakeEvent);
      }
    }
  };

  const handleBlur = e => {
    const parsedNumber = parseNumber(e.target.value);
    setFormattedValue(formatNumber(parsedNumber));

    if (onBlur && typeof onBlur === 'function') {
      const fakeEvent = { ...e };
      fakeEvent.target.value = parsedNumber;
      onBlur(fakeEvent);
    }
  };

  return (
    <TextField
      value={formattedValue}
      onChange={handleChange}
      onBlur={handleBlur}
      slotProps={{
        ...(props.slotProps || {}),
        input: {
          pattern: '^[0-9,]*$',
          inputMode: 'decimal',
        },
      }}
      {...props}
    />
  );
}

export default NumberField;
